import React, { useCallback, useRef, useState, useMemo, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";


import { toggleLoader } from "../../redux/actions/loader.action";
import FileDownloadService from "../../services/file-download-services";
import Toaster from '../../services/toaster.services';
import { addOrganization, getDefaultOrganizations, getOrganization } from "../../api/organization/organization";

//commonComponent
import Tab from "../../shared/components/commonui/Tabs";
import SubHeader from "../../shared/components/commonui/SubHeader/SubHeader";

//Internal data sharing components
import ContractTable from "./Tables/contracts/ContractTable";
import DataSharingTable from "./Tables/sharing/DataSharingTable";
import OrganizationTable from "./Tables/organizations/OrganizationTable";

//css file
import './index.scss'
import { addConracts, getContracts } from "../../api/dataSharing/Contracts";
import { useScreenSize } from "../../utils/media-query";

function SharingComponent(props: ContractProps) {
    const { toggleLoader } = props;
    const [activeTab, setActiveTab] = useState<number>(0);
    const [isVisiblePopup, setisVisisblepopup] = useState<boolean>(false);
    const [orgVisible, setOrgVisible] = useState<boolean>(false);
    const [importedOrgDetails, setImportedOrgDetails] = useState<Array<any>>([]);
    const [currentOrgDetails, setCurrentOrgDetails] = useState<any>({});
    const [currentOrgSelected, setCurrentOrgSelected] = useState<any>();
    const [selectedContract, setSelectedContract] = useState<any>({});
    const [forceUpdate, setForceUpdate] = useState<boolean>(false);
    const [searchContract, setSearchContract] = useState<string>('');
    const [searchTextContract, setSearchTextContract] = useState<any>([]);
    const [searchValueOrg, setSearchValueOrg] = useState<string>('');
    const [searchShare, setSearchShare] = useState<string>('');
    const inputFileRef = useRef<HTMLInputElement | null>();
    const inputFileRefOrganization = useRef<HTMLInputElement | null>();
    const fileDownloadService = useMemo(() => new FileDownloadService(), []);
    const tabs = useMemo(() => [{ tagId: 1, name: "Organization" },
    { tagId: 2, name: "Contracts" }, { tagId: 3, name: "Shared Data" }], []);
    const [tabsWidth, setTabsWidth] = useState<number | string>('auto');
    const { isXSmall } = useScreenSize();

    const getCurrentOrganizationDetails = useCallback(() => {
        return getDefaultOrganizations({ "IsDefaultOrg": true })
    }, []);

    const initializeComponent = useCallback(() => {
        toggleLoader(true);
        Promise.all([getCurrentOrganizationDetails()]).then((responseList: any) => {
            if (responseList.length > 0) {
                setCurrentOrgDetails(responseList[0].data.data[0]);
            }
            toggleLoader(false);
        }).catch((errorList: any) => {
            toggleLoader(false);
            console.log(errorList, "values")
        })
    }, [getCurrentOrganizationDetails, toggleLoader]);

    // Create Contract and ORG
    const createOrganizationAndContract = useCallback(async (dataObject: any, contractCase?: string) => {
        toggleLoader(true);
        const contractDataObject = { "SenderOrgId": dataObject["SenderOrgId"], "ReceiverOrgId": dataObject["ReceiverOrgId"], "Seed": dataObject["Seed"] };
        let ORGId = dataObject["ReceiverOrgId"];

        if (contractCase === "import") {
            ORGId = dataObject["SenderOrgId"];
            contractDataObject["UID"] = dataObject["UID"];
        }

        const contractData = [contractDataObject];

        const orgInfoBody = { "ORGId": ORGId };

        try {
            const organizationInfoResponse = await getOrganization(orgInfoBody);
            if (organizationInfoResponse?.data?.data?.length > 0) {
                const addContractResult = await addConracts(contractData);
                const status = addContractResult.status;
                if (status === 200) {
                    Toaster.successToaster("createOrganizationAndContract", "Contact Crated");
                    setisVisisblepopup(false);
                    setForceUpdate((prev) => !prev);
                }
            }
            else {
                Toaster.errorToaster("Please add organization first");
            }

            toggleLoader(false);
           


            //todo Throw new error if ES<20 (create a common error handler for that); 
        }
        catch (error: any) {
            toggleLoader(false);
            setisVisisblepopup(false);
            if (error?.response?.data?.errors?.length > 0) {
                for (let i = 0; i < error.response.data.errors.length; i++) {
                    Toaster.errorToaster(error.response.data.errors[i]?.message);
                }
            }
        }
    }, [toggleLoader])

    useEffect(() => {
        initializeComponent();
        // Run only once on mount; avoid re-running when callback identity changes (e.g. after Redux updates)
    }, []);
    // handle import contract
    const contractImporterHandler = useCallback((orgDetails: any) => {
        createOrganizationAndContract(orgDetails, "import");
    }, [createOrganizationAndContract]);

    const itemRender = useCallback((params: any) => {
        return (
            <span>
                {params.name}
            </span>
        )
    }, []);

    useEffect(() => {
        setTabsWidth(isXSmall ? '100%' : 'auto');
      }, [isXSmall]);

    // Tab Data Change
    const handleTab = useCallback((event: any) => {
        setActiveTab(event.itemIndex)
    }, [])

    const handlePopup = useCallback(() => {
        setisVisisblepopup((prevValue) => !prevValue);
    }, []);


    const onImportButtonClick = useCallback(() => {
        inputFileRef.current.click();
    }, [inputFileRef]);

    const onExportButtonClick = useCallback((values) => {
        const orgDataJson = {
            ORGName: currentOrgDetails.ORGName,
            ORGId: currentOrgDetails.ORGId,
            ChainAddress: currentOrgDetails.ChainAddress
        }
        
        const orgName = currentOrgDetails?.ORGName ?? '';
        const orgId = currentOrgDetails.ORGId ?? '';
         const fileName = orgName && orgId
             ? `${orgName} (${orgId}).org`
             : 'organization';
        fileDownloadService.objectToJsonFile(orgDataJson, fileName);
    }, [currentOrgDetails, fileDownloadService]);

    const fileUploadHandler = useCallback((event: any) => {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        fileDownloadService.getFileAndParseToJson(file).then((result: any) => {
            const orgDetails = JSON.parse(result);
            if ((orgDetails["ReceiverOrgId"] === currentOrgDetails.ORGId)) {
                contractImporterHandler(orgDetails);
            }
            else {
                Toaster.errorToaster("Invalid Contract")
            }
        }).catch((error) => {
            console.log("fileUploadHandler", error);
        });
        if (inputFileRef.current?.value) {
            inputFileRef.current.value = '';
        }

    }, [contractImporterHandler, currentOrgDetails.ORGId, fileDownloadService]);

    const organizationImportHandler = useCallback((orgDetails: any) => {
        // Popup Open
        setImportedOrgDetails(orgDetails);
        setOrgVisible(true)
    }, []);

    const createOrganization = useCallback(async (dataObject: any,) => {
        toggleLoader(true);
        const orgData = [{
            "ChainAddress": dataObject["ChainAddress"],
            "ORGName": dataObject["ORGName"],
            "ORGId": dataObject['ORGId']
        }];
        const orgInfoBody = { "ORGId": dataObject['ORGId'] };

        try {
            const organizationInfoResponse = await getOrganization(orgInfoBody);
            if (organizationInfoResponse?.data?.data?.length > 0) {
                Toaster.infoToaster("Org Already Exists");
            }
            else {
                const addOrganizationResult = await addOrganization(orgData);

                if (addOrganizationResult.status === 200) {
                    if (addOrganizationResult?.data?.data?.ES > 20) {
                        Toaster.successToaster("createOrganizationAndContract", "Added organization");
                        setForceUpdate((prev) => !prev)
                    }
                    else {
                        Toaster.errorToaster("Failed Adding Organization")
                    }
                }
            }
            setOrgVisible(false);
            toggleLoader(false);
        }
        catch (error: any) {
            toggleLoader(false);
            if (error?.response?.data?.errors?.length > 0) {
                for (let i = 0; i < error.response.data.errors.length; i++) {
                    Toaster.errorToaster(error.response.data.errors[i]?.message);
                }
            }
        }
    }, [toggleLoader]);


    const onImportButtonClickOrganisation = useCallback(() => {
        inputFileRefOrganization.current.click();
    }, []);

    const fileUploadHandlerOrganization = useCallback((event: any) => {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        fileDownloadService.getFileAndParseToJson(file).then((result: any) => {
            const orgDetails = JSON.parse(result);
            if ((orgDetails["ORGId"] && orgDetails["ORGName"] && orgDetails["ChainAddress"]) && (orgDetails["ORGId"] !== currentOrgDetails.ORGId)) {
                organizationImportHandler(orgDetails);
            }
            else {
                Toaster.errorToaster("Invalid Org file")
            }
        }).catch((error) => {
            console.log("fileUploadHandler", error);
        });
        if (inputFileRefOrganization.current?.value) {
            inputFileRefOrganization.current.value = '';
        }
    }, [currentOrgDetails.ORGId, fileDownloadService, inputFileRefOrganization, organizationImportHandler]);


    const handleOrganizationDetails = useCallback((orgDetails: any) => {
        createOrganization(orgDetails);
    }, [createOrganization])

    const orgActionHandler = useCallback((orgDetail: any) => {
        setCurrentOrgSelected(orgDetail)
    }, []);


    const handleContractSelection = (contractDetails: any) => {
        setSelectedContract(contractDetails);
        setActiveTab(2);
    }

    // Search Organization
    const onSearchOrganization = (orgValue: any) => {
        setSearchValueOrg(orgValue);
    }




    //  Search Contract
    const onSearchContract = (contVal: any) => {
        setSearchContract(contVal);
    }



    const searchContractValue = useCallback((contractValue: any) => {
        toggleLoader(true);
        getContracts(contractValue).then(res => {
            toggleLoader(false);
        }).catch(err => {
            toggleLoader(false);
            console.log(err, "Error Search")
        })
    }, [toggleLoader])

    useEffect(() => {
        searchContractValue({ IsDefaultOrg: false })
    }, [searchContract, searchContractValue])


    // Search Share
    const onSearchShare = (shareValue: any) => {
        setSearchShare(shareValue);
    }

    return (
        <div className="view data-share-list">
            <div className='view-wrapper view-wrapper-share-list list-page'>
                {/* Sub Header Component */}
                {/* Todo Create a component for uploading file which is hidden*/}
                <input type="file" id="file" ref={inputFileRef} style={{ display: 'none' }} onChange={fileUploadHandler} accept="application/JSON" />
                <input type="file" id="fileImportOrganization" ref={inputFileRefOrganization} style={{ display: 'none' }} onChange={fileUploadHandlerOrganization} accept="application/JSON" />
                {
                    activeTab === 0 ? <SubHeader
                        title="Data Sharing"
                        value={searchValueOrg}
                        onInput={(e: any) => onSearchOrganization(e.event.target.value)}
                        itemRendererOption={{
                            searchBoxProps: true,
                            btn1Props: {
                                showBtn: true,
                                btnProps: {
                                    text: 'Export',
                                    onClick: onExportButtonClick,
                                },
                            },
                            btn2Props: {
                                showBtn: true,
                                btnProps: {
                                    text: 'Import',
                                    onClick: onImportButtonClickOrganisation
                                }
                            }
                        }}
                    /> : null
                }

                {
                    activeTab === 1 ? <SubHeader
                        title="Data Sharing"
                        value={searchContract}
                        onInput={(e: any) => onSearchContract(e.event.target.value)}
                        itemRendererOption={{
                            searchBoxProps: true,
                            btn1Props: {
                                showBtn: true,
                                btnProps: {
                                    text: 'Create',
                                    onClick: handlePopup,
                                },
                            },
                            btn2Props: {
                                showBtn: true,
                                btnProps: {
                                    text: 'Import',
                                    onClick: onImportButtonClick
                                }
                            }
                        }}
                    /> : null
                }

                {
                    activeTab === 2 ? <SubHeader
                        title="Data Sharing"
                        value={searchShare}
                        onInput={(e: any) => onSearchShare(e.event.target.value)}
                        itemRendererOption={{
                            searchBoxProps: true,
                        }} /> : null
                }
                <div className='dx-card details-card'>
                    <Tab
                        width={tabsWidth}
                        scrollByContent
                        showNavButtons={false}
                        dataSource={tabs}
                        selectedIndex={activeTab}
                        className="dataSharing-tabs"
                        itemRender={itemRender}
                        onItemClick={(event: any) => {
                            handleTab(event)
                        }}
                    />

                    <div className="InnerDetails">
                        <div className="InnerDetailsTable">
                            {
                                activeTab === 0 && (
                                    <OrganizationTable
                                        orgVisible={orgVisible}
                                        setOrgVisible={setOrgVisible}
                                        importedOrgDetails={importedOrgDetails}
                                        handleOrganizationDetails={handleOrganizationDetails}
                                        setActiveTab={setActiveTab}
                                        setisVisisblepopup={setisVisisblepopup}
                                        actionButtonHanlder={orgActionHandler}
                                        forceUpdate={forceUpdate}
                                        setForceUpdate={setForceUpdate}
                                    />
                                )
                            }
                            {
                                activeTab === 1 && (
                                    <div>
                                        <ContractTable
                                            activeTab={activeTab}
                                            isVisiblePopup={isVisiblePopup}
                                            setisVisisblepopup={setisVisisblepopup}
                                            initialSelectedOrg={currentOrgSelected}
                                            handleContractSelection={handleContractSelection}
                                            createOrganizationAndContract={createOrganizationAndContract}
                                            searchTextContract={searchTextContract}
                                            setSearchTextContract={setSearchTextContract}
                                            forceUpdate={forceUpdate}
                                        />
                                    </div>
                                )
                            }

                            {
                                activeTab === 2 && (
                                    <div>
                                        <DataSharingTable
                                            contractDetails={selectedContract}
                                        />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = () => (dispatch: any) =>
    bindActionCreators({ toggleLoader: toggleLoader }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(SharingComponent);

interface ContractProps {
    toggleLoader: any;
}
